import React, { useEffect, useState } from "react";
import {
  createCountry,
  deleteCountry,
  getCountries,
  updateCountry,
} from "../../api/countries/countriesApi";
import { Country } from "../common/ObjectTypes";
import CountriesController from "./CountriesList";
import { toast } from "react-toastify";

const ManageCountriesController = () => {
  const [pageLoaded, setPageLoaded] = useState(false);
  const [countries, setCountries] = useState<Country[]>([]);
  const [addCountry, setAddCountry] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<Country>({
    name: "",
    id: "",
    description: "",
  });
  const [countryToAdd, setCountryToAdd] = useState<Country>({
    name: "",
    id: "",
    description: "",
  });

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const temp = await getCountries(25);
        setCountries(temp);
        setPageLoaded(true);
      } catch (err) {
        console.log(err);
      }
    };
    if (!pageLoaded) loadCountries();
  }, [pageLoaded]);

  const handleOnClickAdd = () => {
    setAddCountry(true);
  };

  const handleSelectCountry = (country: Country) => {
    setSelectedCountry({
      name: country.name,
      id: country.id,
      description: country.description,
      rowVersion: country.rowVersion,
    });
  };

  const handleChange = (e: any) => {
    setSelectedCountry((prev: Country) => ({
      ...prev,
      name: e.target.value,
    }));
  };

  const handleChangeNewCountry = (e: any) => {
    setCountryToAdd((prev: Country) => ({
      ...prev,
      name: e.target.value,
    }));
  };

  const handleUpdateCountry = async () => {
    try {
      await updateCountry(selectedCountry);
      toast.success("Country updated.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveNew = async () => {
    try {
      await createCountry({ name: countryToAdd.name, description: "" });
      toast.success(countryToAdd.name + " added.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setAddCountry(false);
      countryToAdd.name = "";
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancelEdit = () => {
    setSelectedCountry({
      name: "",
      id: "",
      description: "",
    });
  };

  const handleCancelAdd = () => {
    setAddCountry(false);
  };

  const handleDelete = async () => {
    try {
      await deleteCountry(selectedCountry.id ? selectedCountry.id : "");
      setSelectedCountry({
        name: "",
        id: "",
        description: "",
      });
      toast.success("Country was deleted.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="">
      <CountriesController
        countries={countries}
        selectedCountry={selectedCountry}
        countryToAdd={countryToAdd}
        addCountry={addCountry}
        onClickAdd={handleOnClickAdd}
        onSelectCountry={handleSelectCountry}
        onChange={handleChange}
        onChangeNewCountry={handleChangeNewCountry}
        onCancelEdit={handleCancelEdit}
        onCancelAdd={handleCancelAdd}
        onSaveNew={handleSaveNew}
        onUpdateCountry={handleUpdateCountry}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default ManageCountriesController;
